module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [(this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "required": "",
      "rules": this.maiorQue150 ? _vm.regrasBasicas : _vm.tituloRules,
      "max-height": "400",
      "counter": "150"
    },
    model: {
      value: (_vm.projeto.titulo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "titulo", $$v)
      },
      expression: "projeto.titulo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de público-alvo",
      "items": _vm.listaTipoPublico,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.projeto.tipoPublico),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "tipoPublico", $$v)
      },
      expression: "projeto.tipoPublico"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Público-alvo estimado",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.publicoAlvo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "publicoAlvo", $$v)
      },
      expression: "projeto.publicoAlvo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', [(_vm.projeto.classificacaoSecundaria.id === 39729) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária do curso",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', [(_vm.projeto.classificacaoSecundaria.id === 44194) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária do curso",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', [(_vm.projeto.classificacaoSecundaria.id === 44195) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária da oficina",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', [(_vm.projeto.classificacaoSecundaria.id === 39730) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária do evento",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id !== 39729 && _vm.projeto.classificacaoSecundaria.id !== 44194 && _vm.projeto.classificacaoSecundaria.id !== 44195) ? _c('p', {
    staticClass: "mt-3"
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [((_vm.projeto.classificacaoSecundaria && _vm.projeto.classificacaoSecundaria.id === 39733)) ? _c('v-checkbox', {
    attrs: {
      "value": true
    },
    on: {
      "change": _vm.onChangeDataSemLimite
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Essa é uma ação contínua, sem data limite")])]
      },
      proxy: true
    }], null, false, 3659365439),
    model: {
      value: (_vm.dataConclusaoSemLimite),
      callback: function($$v) {
        _vm.dataConclusaoSemLimite = $$v
      },
      expression: "dataConclusaoSemLimite"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de início",
      "required": "",
      "type": "date",
      "rules": _vm.regrasBasicas,
      "disabled": _vm.projeto.relatorioFinalHabilitado === true
    },
    model: {
      value: (_vm.projeto.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "dataInicio", $$v)
      },
      expression: "projeto.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de conclusão",
      "required": "",
      "type": "date",
      "rules": _vm.dataConclusaoRules,
      "disabled": _vm.projeto.relatorioFinalHabilitado === true
    },
    model: {
      value: (_vm.projeto.dataConclusao),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "dataConclusao", $$v)
      },
      expression: "projeto.dataConclusao"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 1",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave01),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave01", $$v)
      },
      expression: "projeto.palavraChave01"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 2",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave02),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave02", $$v)
      },
      expression: "projeto.palavraChave02"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 3",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave03),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave03", $$v)
      },
      expression: "projeto.palavraChave03"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 4",
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave04),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave04", $$v)
      },
      expression: "projeto.palavraChave04"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Resumo",
      "required": "",
      "rules": _vm.resumoRules,
      "rows": 5,
      "counter": "1000"
    },
    model: {
      value: (_vm.projeto.resumo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "resumo", $$v)
      },
      expression: "projeto.resumo"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjeto(false)
      }
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjeto(true)
      }
    }
  }, [_vm._v("Salvar e Avançar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67087c35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/editar-informacoes.vue
// module id = 515
// module chunks = 0